var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.useMessage.所属项目)?_c('detail',{attrs:{"useMessage":_vm.useMessage}}):_c('clist',{attrs:{"title":'客户信息完善',"req":{  }},on:{"click":_vm.onUserSelect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }